/* eslint semi:0 */
import BaseStore from '../baseStore'
import { TYPES as AD_TYPES } from '../../actions/adActions'
import { queryString } from '../../../utils/window'
import { domainFromFqdn } from '../../../utils/ua'
import { info } from '../../../application/console'
import { makeEmptyObj } from '../../../utils/object'
import { TYPES as ROUTER_TYPES } from '../../actions/routerActions'
import { BROWSI_ACTIONS } from '../../actions/browsiActions'
import { toCamelCase, randId } from '../../../utils/string'
import { TYPES as USER_ACTION_TYPES } from '../../actions/userToolbarActions'
import { heartBeat, pageViewed, TYPES as ANALYTICS_TYPES } from '../../actions/analyticsActions'
import { getIsPostPage } from '../../../application/pageDataObject'
import { TYPES as SOCIAL_BUTTONS_TYPES } from '../../actions/socialButtonsActions'
import { actions as fresh8Actions } from '../../../../components/fresh8/fresh8Actions'
import { FANTASY_ACTION_TYPES } from '../../../../components/fantasy/fantasyActionTypes'
import { SOCIAL_BAR_ACTION_TYPES } from '../../../../components/reactions/socialBarActionTypes'
import { FACEBOOK_BOT_ACTION_TYPES } from '../../../../components/facebook_bot/facebookBotActionTypes'

const { debugAnalyticsStore } = queryString
const ANALYTICS_ACTION_TYPES = [
  ...Object.values(ANALYTICS_TYPES),
  ...Object.values(SOCIAL_BUTTONS_TYPES),
  ...Object.values(AD_TYPES),
  ...Object.values(USER_ACTION_TYPES),
  ...Object.values(BROWSI_ACTIONS),
  fresh8Actions.FRESH8_ACTION_TYPES.DISPLAY_POPUP,
  ROUTER_TYPES.ROUTE_CHANGED,
  SOCIAL_BAR_ACTION_TYPES.REACTIONS.DISPLAY,
  SOCIAL_BAR_ACTION_TYPES.REACTIONS.SEND_VOTE,
  FANTASY_ACTION_TYPES.TOURNAMENT.LOAD_MORE,
  FANTASY_ACTION_TYPES.TOURNAMENT.GET_TOURNAMENTS_FEED,
  FANTASY_ACTION_TYPES.TOURNAMENT.SELECT_TOURNAMENT,
  FACEBOOK_BOT_ACTION_TYPES.GO_TO_MESSENGER_BOT,
]

const HEART_BEAT_PERIOD = 30e3 // half a minute
const HEART_BEAT_BLACK_LIST_BY_DOMAIN = ['12up']

function isHeartBeatNotBlackListedForCurrentDomain() {
  return !HEART_BEAT_BLACK_LIST_BY_DOMAIN.includes(domainFromFqdn)
}

export default class AnalyticsStore extends BaseStore {
  constructor(options = {}) {
    super(options)
    this.reset()
    this.listenToBrowserEvents()
  }

  listenToBrowserEvents() {
    window.addEventListener('DOMContentLoaded', pageViewed)
  }

  routeAction(action) {
    if (debugAnalyticsStore) {
      info('STORE EMIT ACTION: ', action)
    }
    action.analyticsActionName = toCamelCase(action.type.replace(/:/g, '_'))
    if (this.isAnalyticsAction(action.type)) {
      this.analyticsEvents.push(action) //Note: maybe this is not really needed... probably will be used just for debugging purpose
      this.recordActionInState(action)
      this.emitChange(action)
    }
  }

  reset() {
    let analyticsEvents = this.state.analyticsEvents || []
    this.state = makeEmptyObj()
    this.state.analyticsEvents = analyticsEvents
    this.generatePageviewUid()
    if (getIsPostPage() && isHeartBeatNotBlackListedForCurrentDomain()) {
      if (this.heartbeatIntervalId) {
        clearInterval(this.heartbeatIntervalId)
      }
      this.heartbeatIntervalId = setInterval(heartBeat, HEART_BEAT_PERIOD)
    }
  }

  generatePageviewUid() {
    this.state.pageviewUid =
      randId() +
      randId() +
      randId() +
      randId() +
      randId() +
      randId() +
      randId() +
      randId() +
      Date.now()
    return this.state.pageviewUid
  }

  isAnalyticsAction(actionType) {
    return ANALYTICS_ACTION_TYPES.includes(actionType)
  }

  emitChange(action) {
    this.emit(this.constructor.EVENTS.CHANGE, action)
    return this
  }

  get analyticsEvents() {
    return this.state.analyticsEvents
  }

  get heartbeatsCount() {
    return this.state.heartBeat || 0
  }

  get pageviewUid() {
    return this.state.pageviewUid
  }

  recordActionInState(action) {
    let actionType = toCamelCase(action.type.split(':').pop())
    this.state[actionType] = (this.state[actionType] || 0) + 1
  }
}

export { HEART_BEAT_PERIOD }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/analytics/analyticsStore.js